// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-bar[data-v-3ade797b]{text-align:right !important}.left-number[data-v-3ade797b]{left:2em;position:absolute}@media(max-width: 991.98px){.text-block[data-v-3ade797b]{display:block}}", ""]);
// Exports
module.exports = exports;
